import { Component, OnInit, ViewContainerRef, ViewChild, AfterViewInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '../Services/UserService';
import { Userclass } from '../Classes/Userclass';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { NgForm } from '@angular/forms';
import { IMyDpOptions, IMyInputFieldChanged, IMyDateModel } from 'mydatepicker';
import { UserPunch } from '../Classes/UserPunch';
import { debug, error } from 'util';
import * as XLSX from 'xlsx';
import { FaceApiService } from '../Services/face-api-service.service';
import * as _ from 'lodash';
import { reverse } from 'dns';
import { MatTableDataSource, MatSort } from '@angular/material';
import { Time } from '@angular/common';
import { Observable } from 'rxjs';
import { saveAs as importedSaveAs } from "file-saver";
import {
  HttpClient,
  HttpRequest,
  HttpEventType,
  HttpResponse,
} from '@angular/common/http';
import { Headers, Http, Response, RequestOptions, ResponseContentType } from '@angular/http';



@Component({
  selector: 'User-Manage',
  templateUrl: '../PDFToExcelImport/PDFToExcel.Component.html',
  styleUrls: ['../../Content/css/bootstrap.css', '../../Content/css/custom.css', '../../Content/css/master.css', '../../Content/css/innflow-top-menu.css',
    '../../Content/css/innflow-main.css', '../../Content/css/jquery.dropdownReplacement.css', '../../Content/css/fixedheader.css',
    '../../Content/css/jquery.dropdownReplacementhotel.css',
    '../../Content/css/table-sorting-example.css'],
  providers: [UserService, FaceApiService],
  // encapsulation: ViewEncapsulation.None
})

export class PDFToExcelComponent implements OnInit, AfterViewInit {
  File: File;
  _UserPunch = new UserPunch();
  _user = new Userclass();
  GetUserDetails: any[] = [];
  GetUserDetailsFiltered: any[] = [];
  dataSource: any = {};
  displayedColumns: any[] = [];
  _SelectedDate: string;
  innerWidth: number;
  GetUserRoles: any = [];
  Loaderimage: string = '../../assets/images/ajax-loader3.gif';
  // fullImagePath: string = '../../Content/images/cal/defalut.jpg';
  loading: boolean = false;
  isColumnHidden: boolean = false;
  UserAdd: string = "none";
  file: File;
  filesToUpload: File[];
  flImport(arg0: any): any {
    throw new Error("Method not implemented.");
  }
  FileModel: any = {};

  PermissionRole: string;
  TitleName: string;
  selectAllRows: boolean = false;
  selectAllRowss: boolean = false;
  shouldBelowTen: boolean = false;
  booleanValue: any = false;
  // these are use for Azure linking
  public personFaces = [];
  public personGroups = [];
  public personList = [];
  public selectedGroupId = '';
  public selectedPerson: any;

  ImportEntitiesdetails: any = [];
  ImportSubscriptiondetails: any = [];
  OrganizationChangeLog: any = [];

  UserStatus: any[] = [
    { Value: 'Active', Text: 'Active' },
    { Value: 'Inactive', Text: 'Inactive' }
  ]
  isValidFormSubmitted = false;
  @ViewChild(MatSort) sort: MatSort

  constructor(private route: ActivatedRoute, private router: Router, private _userservice: UserService, private _FaceApiService: FaceApiService,
    private http: Http,
    public toastr: ToastsManager, vcr: ViewContainerRef) {
    this.toastr.setRootViewContainerRef(vcr);
    this.innerWidth = 100;
  }

  ngOnInit() {
    this.ChangeHeadeFooterColor();
    

    const ELEMENT_DATA: Element[] = [];
    this.dataSource = new MatTableDataSource(ELEMENT_DATA);
    
    // GetAllUserdetails();
    //this.GetAllRoles();
  }
  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

  /*Multiple*/

  fileChange(event: any) {

    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      this.File = fileList[0];
    }
  }

  ImportFile(form: NgForm) {
    

    if (form.controls.AttachFile.value != null) {
       this.loading = true;
      let file: File = this.File;
      let formData: FormData = new FormData();
      formData.append('uploadFile', file, file.name);
      let headers = new Headers()

      let param = {
        "UserName": JSON.stringify(sessionStorage.getItem('UserName'))
      };
      //let options = new RequestOptions({ headers: headers, params: param });
      let options = new RequestOptions({ responseType: ResponseContentType.Blob });
      let apiUrl1 = "api/Organization/PDFToExcelFile";
      this.http.post(apiUrl1, formData, options)
        .map(res => res.json())
        .catch(error => Observable.throw(error))
        .subscribe(res => {
          var blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          this.loading = false;
          importedSaveAs(blob, file.name.replace(".pdf", ".xlsx"));
          form.reset();
         

        })
    }
    else {
     this.loading = false;
      this.toastr.error('Please select file.');
    }
  }
  /*Multiple*/





  get_url: string = '';
  public ChangeHeadeFooterColor() {

    this.get_url = window.location.origin;
    if (this.get_url == "https://localhost:44335") {
      var a = document.getElementById("mainbox");
      a.style.backgroundColor = "#cc4141";

      var footer = document.getElementById("footer");
      footer.style.background = "#cc4141";

      var header = document.getElementById("header");
      header.style.background = "#cc4141";

      // var mnu_Reports = document.getElementsByTagName("ul[_ngcontent-c2] li[_ngcontent-c2]");


    }
    else if (this.get_url == "https://inn-flowmgt-test.azurewebsites.net") {
      var a = document.getElementById("mainbox");
      a.style.backgroundColor = "#cc4141";

      var footer = document.getElementById("footer");
      footer.style.background = "#cc4141";

      var header = document.getElementById("header");
      header.style.background = "#cc4141";

    }
    else if (this.get_url == "https://inn-flowmgt-staging.azurewebsites.net") {
      var a = document.getElementById("mainbox");
      a.style.backgroundColor = "#ed7d31";

      var footer = document.getElementById("footer");
      footer.style.background = "#ed7d31";

      var header = document.getElementById("header");
      header.style.background = "#ed7d31";
    }
  }

  GetAllRoles() {
    this._userservice.GetAllRoles().subscribe(res => {
      var data = res;
      this.GetUserRoles = data;
    })
  }

  SaveUserDetails(form: NgForm) {
    this._user.BCCEmail = sessionStorage.getItem('BCCEmail');
    this._user.FirstName = this._user.FirstName.trim();
    this._user.FirstName = this._user.FirstName.charAt(0).toUpperCase() + this._user.FirstName.slice(1).toLowerCase();
    this._user.LastName = this._user.LastName.trim();
    this._user.LastName = this._user.LastName.charAt(0).toUpperCase() + this._user.LastName.slice(1).toLowerCase();
    var LnameLength = this._user.LastName.length;
    var LastChar = this._user.LastName.substring(LnameLength - 1, LnameLength)

    if (this.isInteger(LastChar)) {
      this.toastr.error('Please enter the valid Last Name.');
      return;
    }
    this._user.Email = this._user.Email.trim();
    this._user.UserName = "";
    this.loading = true;
    this._userservice.SaveUserDetails(this._user).subscribe(res => {
      var data = res;
      if (!data.Message) {
        this.toastr.success(data[0].message);
        this.UserAdd = "none";
        // this.GetAllUserdetails();
        this.loading = false;
        form.reset();
      }
      else {
        this.toastr.error(data.Message);
        this.loading = false;
      }
    })
  }




  EditUserInfo(Userdetails: any) {
    debugger;
    this.loading = true;
    // this.selectedPerson.personId = "c865cd0b-0027-4b94-aa02-32e936f7bf59";// Userdetails;// person;
    this.selectedPerson = Userdetails;
    this.personFaces = [];
    debugger;
    this._FaceApiService.getPersonFaces(this.selectedPerson.personGroupId,
      this.selectedPerson.personId).subscribe((person: any) => {

        for (const faceId of person.value.persistedFaceIds) {
          this._FaceApiService.getPersonFace(this.selectedPerson.personGroupId,
            this.selectedPerson.personId, faceId).subscribe(data => {
              this.personFaces.push(data);
            });
        }

        this._user.Type = "Update";
        this.UserAdd = "block";
        this.loading = false;

      }, error => {
        if (error.status === 404) {
          this.loading = false;
          this.toastr.error("The face is not found.");
        }
      });
  }

  //  , error => {

  //  this.loading = false;
  //  this.toastr.error("The face is not found.");
  //}


  AddNew() {
    this._user.FirstName = null;
    this._user.LastName = null;
    this._user.UserName = null;
    this._user.Email = null;
    this._user.Status = this.UserStatus[0].Value;
    this._user.RoleID = null;
    this._user.Useruniqueno = null;
    this.PermissionRole = null;
    this._user.Type = "Add";
    this.UserAdd = "block";
    this.TitleName = "Create New User";
  }


  HidePwdPopUp(form: NgForm) {
    this.UserAdd = "none";
    form.reset();
  }

  isInteger(value) {
    if (value.indexOf('.') != -1) {
      return false;
    }
    if ((undefined === value) || (null === value)) {
      return false;
    }
    return value % 1 == 0;
  }

  TrimEmail(Email: string) {
    this._user.Email = Email.trim();
    return this._user.Email;
  }




}
interface CertificateSubmissionResult {
  fileName: string;
  fileSize: number;
}

export interface Element {
  tenantID: number;
  ehid: number;
  userName: string;
  dateTime: string;
  percentageMatch: string;
  image: string;
  checked: boolean;
  persistedFaceIds: string;
  personGroupId: string;
  personId: string;
  uniqueno: string;
  date: string;

}

function formatDate(date) {
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();
  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;
  return [year, month, day].join('/');
}





// WEBPACK FOOTER //
// ./src/app/PDFToExcelImport/PDFComponent.ts